import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { I18nModule } from "@spartacus/core";
import { ExternalsiteAlertComponent } from "./externalsite-alert/externalsite-alert.component";


@NgModule({
  declarations: [ExternalsiteAlertComponent],
  imports: [
    CommonModule,
    I18nModule
  ],
  exports: [ExternalsiteAlertComponent],
  providers: [
  ]
})
export class ExternalsiteAlertModule { }
